import React from 'react';
import { useLocation } from 'react-router-dom';
import NavBar from 'src/containers/NavBar';
import SubNav from 'src/containers/SubNav';
import PageContainer from 'src/components/PageContainer';
import ReportsChp from 'src/containers/Reports/Chp';
import Macra2024 from 'src/containers/Reports/Macra/2024';
import Macra2025 from 'src/containers/Reports/Macra/2025';

function ReportsContainer() {
    const location = useLocation();

    function getCurrentReport() {
        if (location.pathname.includes('chp')) {
            return <ReportsChp />;
        } else if (location.pathname.includes('macra/2024')) {
            return <Macra2024 />;
        } else if (location.pathname.includes('macra')) {
            return <Macra2025 />;
        }
    }

    return (
        <PageContainer>
            <NavBar />
            <SubNav type="reports" />
            {getCurrentReport()}
        </PageContainer>
    );
}

export default ReportsContainer;
